module.exports = __webpack_public_path__ + "images/dingtalk/icon-document-f723e5c2456ac3e9078ccce3462afc93.png";